


  <!-- App Header -->
  <!-- <div class="appHeader text-light">    
    <div class="pageTitle">Thai 2D3D</div>    
</div> -->

<div id="appCapsule"> 
  <div class="container-fluid">
    <app-twod-live></app-twod-live>
</div>
</div>
<!-- * App Capsule -->
